import { render } from "./createReserveTypesComponent.vue?vue&type=template&id=1628df1c"
import script from "./createReserveTypesComponent.vue?vue&type=script&lang=js"
export * from "./createReserveTypesComponent.vue?vue&type=script&lang=js"

import "./createReserveTypesComponent.vue?vue&type=style&index=0&id=1628df1c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__